import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { EcmRouterModule, LinkService, TrackingData } from '@ecm/router';

import { UniverseEnum } from '../../../../business/api/dashboard/universeEnum';
import { MultiContractViewModel } from '../../../../business/model/crossroads/contracts-options/multi-contract.view-model';
import { ContractsViewModel } from '../../../../business/model/crossroads/contracts.view-model';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';
import { ParamsUtils } from '../../../../utils/params.utils';
import { AbstractComponent } from '../../../shared/abstract.component';

@Component({
    selector: 'ecm-multi-contract-bill',
    templateUrl: 'multi-contract-bill.html',
    styleUrls: ['multi-contract-bill.css'],
    standalone: true,
    imports: [NgClass, AsyncPipe, EcmRouterModule, TranslateModule],
})
export class MultiContractBillComponent extends AbstractComponent implements OnInit {
    @Input()
    public viewModel: ContractsViewModel;

    @Input()
    public hideBorder: boolean;

    @Input()
    public universe: UniverseEnum;

    public multiContractViewModel: MultiContractViewModel;

    /**
     * Generated link to multiContract page
     * @type {Observable<string>}
     */
    public openBillMultiContractLink: Observable<string> = null;

    /**
     * Generated link to eSIM page
     * @type {Observable<string>}
     */
    public openESimLink: Observable<string> = null;

    /**
     * Generated link to bill page
     * @type {Observable<string>}
     */
    public billLink: Observable<string> = null;

    private readonly billPageLinkUrl: string = 'facture-paiement/{{cid}}';

    /**
     * GA tracking area
     * @type {string}
     */
    private readonly trackingArea: string = 'care_selectionfacture_factures';

    private readonly translate = inject(TranslateService);
    private readonly linkService = inject(LinkService);

    public constructor() {
        super();
        this.translate.use('fr');
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (this.viewModel.contract) {
            this.multiContractViewModel = this.viewModel.contract as MultiContractViewModel;
        }
    }

    /**
     * Open button link for multi contract
     * @param link
     */
    public openBillMultiContract(link: any): void {
        this.translate.get('dashboard.contractsAndOptions.multiContract').subscribe((multiContract: any) => {
            this.linkService.openLink(
                link,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.bills,
                        trackingArea: this.trackingArea,
                        trackingName: multiContract['button'],
                    },
                }),
                null,
                null,
                true,
            );
        });
    }

    /**
     * Open button link for eSIM activation
     * @param link
     */
    public openBillButtonESimLink(link: any): void {
        this.translate.get('dashboard.contractsAndOptions.multiContract.parnasse').subscribe((parnasse: any) => {
            this.linkService.openLink(
                link,
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.contractsAndOptions,
                        trackingArea: this.trackingArea,
                        trackingName: parnasse['eSimLabel'],
                    },
                }),
                ParamsUtils.cidMap(this.multiContractViewModel.cid),
            );
        });
    }

    /**
     * Go to contract bill page
     */
    public openBill(): void {
        this.translate.get('dashboard.bills.button.paidYourBill').subscribe((label: string) => {
            this.linkService.openLink(
                {
                    inApp: this.billPageLinkUrl,
                },
                Object.assign(new TrackingData(), {
                    tmsTracking: {
                        trackedPage: TrackedPage.bills,
                        trackingArea: 'care_selectionfacture_factures',
                        trackingName: label,
                    },
                }),
                ParamsUtils.cidMap(this.multiContractViewModel.cid),
            );
        });
    }
}
